/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import SVGIcon from 'react-md/lib/SVGIcons/SVGIcon';
import './icon.module.scss';

const Finish = props => (
  <SVGIcon {...props} role="presentation" viewBox="87 87 26 26">
    <circle fill="#fdda78" cx="100" cy="100" r="13" />
    <rect
      fill="#f5f5f5"
      x="95.13"
      y="94.34"
      width="13.5"
      height="10.13"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 184.949997, 214.990005)"
    />
    <rect
      fill="#1f2121"
      x="105.77"
      y="95.27"
      width="3.38"
      height="3.38"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 196.440002, 211.100006)"
    />
    <rect
      fill="#1f2121"
      x="101.85"
      y="98.01"
      width="3.38"
      height="3.38"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 188.199997, 215.860001)"
    />
    <rect
      fill="#1f2121"
      x="99.12"
      y="94.1"
      width="3.38"
      height="3.38"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 183.440002, 207.619995)"
    />
    <rect
      fill="#1f2121"
      x="95.21"
      y="96.84"
      width="3.38"
      height="3.38"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 175.210007, 212.380005)"
    />
    <rect
      fill="#1f2121"
      x="104.59"
      y="101.92"
      width="3.38"
      height="3.38"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 192.960007, 224.100006)"
    />
    <rect
      fill="#1f2121"
      x="97.94"
      y="100.75"
      width="3.38"
      height="3.38"
      transform="matrix(-0.984808, -0.173648, 0.173648, -0.984808, 179.960007, 220.619995)"
    />
    <path
      fill="#1f2121"
      d="M95.45,91a1,1,0,0,0-1.21.85l-3.11,17.62A13.14,13.14,0,0,0,93,110.94l3.3-18.72A1,1,0,0,0,95.45,91Z"
    />
  </SVGIcon>
);

export default Finish;
